<template>
    <div class="miniAudio" @click="goAudio" ref="miniAudio" v-show="isShowMini">
        <audio @play="watchPlay" @pause="watchPause" @ended="watchEnded" @timeupdate="watchTimeupdate" @canplay="watchCanplay" @stalled="watchStalled" @error="watchError" @progress="watchProgress" controls autoplay ref="audio" style="display: none;" >
            <source :src="audioUrl" type="audio/mpeg">
        </audio>
        <div>
            <img :src="$store.state.bookInfo.cover" alt="" ref="bookCover">
            <div>
                <img src="../assets/imgs/audios/fixedPlay.gif" alt="">
            </div>
        </div>
    </div>
     <!-- @canplaythrough="watchCanplaythrough" -->
</template>

<script>
let Base64 = require('js-base64').Base64;
import wx from 'weixin-js-sdk'
export default {
    data() {
        return {
            decodeToken: null,
            chapterAudio: "",
            isShowMini: false,
            timer: null,
            // direction: 'no',
            // draw: false,
            audioInfo: {},
            isMoreList: true,
            direction: "no",
            isHistory: true,
            historyTime: 0,
        }
    },
    computed:{
        playbackRate(){
            return this.$store.state.audioInfo.playbackRate;
        },
        isPlay(){
            return this.$store.state.audioInfo.isPlay;
        },
        firstPlay(){
            return this.$store.state.audioInfo.firstPlay;
        },
        getRoutePath() {
            return this.$route.name;
        },
        times() {
            return this.$store.state.setTimes;
        },
        bookId() {
            return this.$store.state.bookId;
        },
        audioUrl() {
            return this.$store.state.actChapter.audioUrl;
        },
        toAudioPage(){
            return this.$store.state.toAudioPage;
        },
        wxConfigData() {
            return  this.$store.state.wxConfigData
        },
        defaultLink(){
            return this.$store.state.defaultLink
        },
        isFirstAudioLoad() {
            return this.$store.state.isFirstAudioLoad
        }
    },
    created() {
        var that = this;
        // if( that.times == 0 ) {
        //     that.$store.commit("setTimesDefault", -1);
        // }
        that.direction = "no";
        if( that.bookId != 0 ){
            if( that.$store.state.toAudioPage == "book" ){
                that.$store.commit("setHistorical", false);
                that.getChapterList();
            }else{
                that.$store.commit("setHistorical", true);
                that.getChapterList();
            }
        }

        if( that.$route.name == "audio") {
            that.busEvent();
        }
        // if( that.wxConfigData.appId ) {
        //     wx.config({
        //         debug:true,
        //         appId: newV.appId,
        //         timestamp:  newV.timestamp,
        //         nonceStr: newV.nonceStr,
        //         signature: newV.signature,
        //         jsApiList:[
        //             'updateTimelineShareData',
        //             'hideMenuItems'
        //         ]
        //     });
        // }
    },
    mounted() {
        var that = this;
        
    },
    destroyed () {
        var that = this;
        // that.Bus.$off(['bookInfo'])
    },
    methods: {
        getChapterList() {
            
            var that = this;
            
            var data = {
                historical: that.$store.state.historical,
                rankOrder: "asc",
                bookId: that.bookId,
                ticket: localStorage.getItem("ticket"),
                page: {
                    pageSize: that.$store.state.chapterPages.pageSize
                }
            }

            if( that.direction == "prev" ) {

                data.page.pageNum = that.$store.state.chapterPages.prevNum;

            }else if( that.direction == "next" ) {

                data.page.pageNum = that.$store.state.chapterPages.nextNum;

            }else if( that.direction == "no" ) {

                data.page.pageNum = that.$store.state.chapterPages.pageNum;

            }
            

            that.allApi.getChapter(data).then((resource)=>{

                // console.log(resource.data)
                that.audioInfo = {};
                if( that.direction == "prev" ) {

                    that.$store.commit("setChapterList", resource.data.data.pageQuery.list.concat(that.$store.state.chapterList));

                }else if( that.direction == "next" ) {

                    that.$store.commit("setChapterList", that.$store.state.chapterList.concat(resource.data.data.pageQuery.list));

                }else if( that.direction == "no" ) {
                    if( that.$store.state.historical ) {
                        if( resource.data.data.historyRank ) {
                            that.historyTime = resource.data.data.history.duration;

                            that.isHistory = true;

                            let chapterHistory = {
                                historyRank: resource.data.data.historyRank,
                            }
                            that.$store.commit("setChapterHistory", chapterHistory);

                            let chapterPages = {
                                totalPage: resource.data.data.pageQuery.totalPage,
                                totalRow: resource.data.data.pageQuery.totalRow,
                                pageNum: resource.data.data.pageQuery.pageNumber,
                                prevNum: resource.data.data.pageQuery.pageNumber,
                                nextNum: resource.data.data.pageQuery.pageNumber,
                            }
                            that.$store.commit("setChapterPages", chapterPages);

                            let actChapter = {
                                actChapterIdx: (resource.data.data.historyRank % 20 != 0) ? (resource.data.data.historyRank % 20 - 1) : 19,
                                rank: resource.data.data.historyRank,
                            }
                            that.$store.commit("setActChapter", actChapter);

                            that.$store.commit("setChapterList", resource.data.data.pageQuery.list);

                            let audioInfo = {
                                currentTime: resource.data.data.history.duration,
                            }

                            that.$store.commit("setAudioInfo", audioInfo);

                        }else{
                            let chapterPages = {
                                totalPage: resource.data.data.pageQuery.totalPage,
                                totalRow: resource.data.data.pageQuery.totalRow
                            }
                            that.$store.commit("setChapterPages", chapterPages);
                            that.$store.commit("setChapterList", resource.data.data.pageQuery.list);

                        }
                        
                    }else{
                        let chapterPages = {
                            totalPage: resource.data.data.pageQuery.totalPage,
                            totalRow: resource.data.data.pageQuery.totalRow
                        }
                        that.$store.commit("setChapterPages", chapterPages);
                        that.$store.commit("setChapterList", resource.data.data.pageQuery.list);

                    }

                }
   
                
                let actChapter = {
                    rank: that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].rank,
                    audioUrl: that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].audioUrl,
                    name: that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].name,
                    chapterid: that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].chapterid,
                }
                that.$store.commit("setActChapter", actChapter);

                let chapterHistory = {
                    historyRank: that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].rank,
                }
                that.$store.commit("setChapterHistory", chapterHistory);

                that.$nextTick(()=>{

                    that.isMoreList = true;

                    // that.scrollH = that.$refs.scrollH.offsetHeight;

                })

            })

        },
        prevChapter() {
            var that = this;

            if( that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].setTime == "y" ) {

                var audioInfo = {
                    setTime: "n"
                }

                that.$store.commit("setAudioInfo", audioInfo);

            }

            that.$refs.audio.pause();

            if( that.$store.state.actChapter.actChapterIdx - 1 < 0 ) {

                if( that.$store.state.chapterPages.prevNum - 1 < 1 ) {

                    let actChapter = {
                        actChapterIdx: 0
                    }

                    that.$store.commit("setActChapter", actChapter);

                    that.Bus.$emit('load');

                    // that.$refs.audio.load();

                }else{

                    that.isMoreList = false;

                    that.direction = "prev";

                    that.$store.commit("setHistorical", false);

                    let chapterPages = {
                        prevNum: (that.$store.state.chapterPages.prevNum - 1)
                    }
                    that.$store.commit("setChapterPages", chapterPages);

                    let actChapter = {
                        actChapterIdx: 19
                    }

                    that.$store.commit("setActChapter", actChapter);

                    that.getChapterList();

                }

            }else{

                let actChapter = {
                    rank: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx - 1)].rank,
                    audioUrl: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx - 1)].audioUrl,
                    name: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx - 1)].name,
                    chapterid: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx - 1)].chapterid,
                    actChapterIdx: (that.$store.state.actChapter.actChapterIdx - 1)
                }
                that.$store.commit("setActChapter", actChapter);
                let chapterHistory = {
                    historyRank: that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].rank,
                }
                that.$store.commit("setChapterHistory", chapterHistory);
                // that.$refs.audio.load();
                // that.$refs.audio.play();
            }

        },
        nextChapter() {
            var that = this;

            if( that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].setTime == "y" ) {

                var audioInfo = {
                    setTime: "n"
                }

                that.$store.commit("setAudioInfo", audioInfo);

            }

            if( localStorage.getItem("showRowNum") != undefined && localStorage.getItem("showRowNum") < that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx+1].rank && localStorage.getItem("status") == 'false' ){

                // alert("请先登录");
                let data = {
                    msg: "请先登录"
                }
                that.$emit("dialogChange", data);

                return false; 

            }else if( localStorage.getItem("status") == 'true' && localStorage.getItem("showRowNum") != undefined && localStorage.getItem("showRowNum") < that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx+1].rank ) {

                // alert("该书没有收听全部章节权限，请联系机构相关人员。");
                let data = {
                    msg: "该书没有收听全部章节权限，请联系机构相关人员。"
                }
                that.$emit("dialogChange", data);

                return false;

            }

            that.$refs.audio.pause();

            if( that.$store.state.actChapter.actChapterIdx + 1 > that.$store.state.chapterList.length - 1 ) {

                if( that.$store.state.chapterPages.nextNum + 1 > that.$store.state.chapterPages.totalPage ) {

                    that.isMoreList = false;

                    that.direction = "no";

                    that.$store.commit("setHistorical", false);

                    let chapterPages = {
                        nextNum: 1,
                        prevNum: 1,
                        pageNum: 1
                    }
                    that.$store.commit("setChapterPages", chapterPages);

                    let actChapter = {
                        actChapterIdx: 0
                    }

                    that.$store.commit("setActChapter", actChapter);

                    that.getChapterList();

                }else{

                    that.isMoreList = false;

                    that.direction = "next";

                    that.$store.commit("setHistorical", false);

                    let chapterPages = {
                        nextNum: 1,
                        prevNum: 1,
                        pageNum: 1
                    }
                    that.$store.commit("setChapterPages", chapterPages);

                    let actChapter = {
                        actChapterIdx: (that.$store.state.actChapter.actChapterIdx + 1)
                    }

                    that.$store.commit("setActChapter", actChapter);

                    that.getChapterList();

                }

            }else{
                // console.log(that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx)].audioUrl)
                let actChapter = {
                    rank: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx + 1)].rank,
                    audioUrl: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx + 1)].audioUrl,
                    name: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx + 1)].name,
                    chapterid: that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx + 1)].chapterid,
                    actChapterIdx: (that.$store.state.actChapter.actChapterIdx + 1)
                }
                that.$store.commit("setActChapter", actChapter);
                let chapterHistory = {
                    historyRank: that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].rank,
                }
                that.$store.commit("setChapterHistory", chapterHistory);
                // console.log(that.$store.state.chapterList[( that.$store.state.actChapter.actChapterIdx + 1)].audioUrl)
                // that.$refs.audio.load();
                // that.$refs.audio.play();
                // alert(that.$refs.audio.paused)
            }

        },
        addHistory() {
            var that = this;
            if( localStorage.getItem("status") == 'false' || !localStorage.getItem("status") ) {
                return false;
            }
            var duration = 1;
            if( that.isHistory ) {
                // that.isHistory = false;
                duration = that.historyTime;  
            }
            var data = {
                bookId: that.bookId,
                chapterId: that.$store.state.actChapter.chapterid,
                duration: duration,
                chapterRank: that.$store.state.actChapter.rank,
                ticket: localStorage.getItem("ticket")
            }
            
            // console.log(data)
            that.allApi.addUserBookHistory(data).then((resource)=>{
                // console.log(resource.data);
                console.log("历史记录添加成功"); 
            })
        },
        watchPlay() {
            var that = this;
            that.$store.commit("addHistory");
        },
        watchPause() {
            var that = this;
            that.$store.commit("clearAddHistory");
        },
        watchStalled() {
            // audio失去数据后重新加载
            var that = this;
            // console.log(11111111)
            // alert(2)
            // that.isHistory = true;
            // that.historyTime = that.$store.state.audioInfo.currentTime;
            // that.$refs.audio.load();

            // // that.$refs.audio.currentTime = that.commin.data.audioData.chapterCurrentTime;
            
        },
        watchError() {},
        watchEnded() {
            var that = this;

            that.$refs.audio.pause();

            if( that.$store.state.chapterList[that.$store.state.actChapter.actChapterIdx].setTime == "y" ) {

                var audioInfo = {
                    setTime: "n"
                }

                that.$store.commit("setAudioInfo", audioInfo);

                return false;

            }else{
                // alert(1)
                that.nextChapter();

            }
        },
        watchTimeupdate() {
            var that = this;
            // console.log(that.$refs.audio.currentTime)
            let audioInfo = {
                currentTime: that.$refs.audio.currentTime
            }
            that.$store.commit("setAudioInfo", audioInfo);
        },
        watchCanplay(){
            var that = this;
            var audioInfo = {
                duration: that.$refs.audio.duration
            }
            that.$store.commit("setAudioInfo", audioInfo);

            that.$refs.audio.playbackRate = that.playbackRate;
            
            if( that.isHistory ) {
                that.isHistory = false;
                that.$refs.audio.currentTime = that.historyTime;  
            }
            // console.log(that.firstPlay)
            // if( that.firstPlay == "n" ) {
                // alert(1)
                that.$refs.audio.play();
            // }
        },
        watchProgress(){
            // alert(1)
        },
        goAudio() {
            var that = this;
            // that.$refs.audio.pause();

            that.$router.push({
                path: `/audio/${that.bookId}`,
                query: {
                    audioType: 'mini',
                }
            });
        },
        busEvent() {
            var that = this;
            // 点击播放页进度条计算的当前音频播放时间
            that.Bus.$on('clickProgress', (val)=>{
                that.$refs.audio.currentTime = val;
            });

            // 滑动播放页进度小圆圈计算的当前音频播放时间
            that.Bus.$on('slidePie', (val)=>{
                that.$refs.audio.currentTime = val;
            });

            // 播放页触发音频暂停
            that.Bus.$on('pause', ()=>{
                that.$refs.audio.pause();
            });

            // 播放页触发音频播放
            that.Bus.$on('play', ()=>{
                that.$refs.audio.play();
            });

            // 播放页触发音频播放
            that.Bus.$on('load', ()=>{
                that.$refs.audio.load();
            });

            // 播放页触发上一首
            that.Bus.$on('prevChapter', ()=>{
                that.prevChapter();
            });

            // 播放页触发下一首
            that.Bus.$on('nextChapter', ()=>{
                that.nextChapter();
            });

            // 播放页触发音频快进15秒
            that.Bus.$on('forward', (val)=>{
                if( val == -1 ) {
                    that.prevChapter();
                    return false;
                }else {
                    that.$refs.audio.currentTime = val;
                }
            });

            // 播放页触发音频后退15秒
            that.Bus.$on('backward', (val)=>{
                if( val == -1 ) {
                    that.nextChapter();
                    return false;
                }else {
                    that.$refs.audio.currentTime = val;
                }
            });

            // 播放页选择章节进行播放
            that.Bus.$on('audioUrl', (audioUrl)=>{
                // that.chapterAudio = audioUrl;
            });
        },
    },
    watch: {
        playbackRate(newV){
            var that = this;
            that.$refs.audio.playbackRate = newV;
        },
        isPlay(newV){
            console.log(newV)
            var that = this;
            if( newV == "y" ) {
                that.$refs.audio.play();
            }else{
                that.$refs.audio.pause();
            }
        },
        getRoutePath(newV) {
            var that = this;
            // console.log(newV)
            if( newV != "audio" && newV != "self" && newV != "login" && that.bookId ) {
                that.isShowMini = true;
            }else{
                that.isShowMini = false;
            }

            if( newV == "audio" ) {
                that.busEvent();
            }
            
        },
        times(newV) {
            var that = this;
            if( newV == 0 ) {
                that.$refs.audio.pause();
            }
        },
        bookId(newV, oldV){
            var that = this;
            console.log(newV, oldV)
            if( newV != oldV ) {
            }
        },
        toAudioPage(newV){
            var that = this;
            if( newV == "book" ) {
                that.direction = "no";
                that.$store.commit("setHistorical", false);
                that.getChapterList();
                that.historyTime = that.$store.state.audioInfo.currentTime;
            }else if( newV == "history" ) {
                that.direction = "no";
                that.$store.commit("setHistorical", true);
                that.getChapterList();
            }
        },
        audioUrl(oldV, newV) {
            var that = this;
            if( oldV != newV ) {
                that.$store.commit("clearAddHistory");
                var data = {
                    ticket: localStorage.getItem("ticket"),
                    bookId: that.bookId
                }
                that.allApi.addBookReadSum(data).then((resource)=>{
                    // console.log(resource.data)
                })

                that.addHistory();
                that.$refs.audio.load();
                that.$refs.audio.play();
            }
        },
        wxConfigData(newV, oldV){
            let that = this;
            
            wx.ready(function(){
                wx.hideMenuItems({
                    menuList: [
                        'menuItem:share:qq',
                        'menuItem:share:weiboApp',
                        'menuItem:share:facebook',
                        'menuItem:favorite',
                        'menuItem:share:QZone',
                        'menuItem:copyUrl',
                        'menuItem:openWithQQBrowser',
                        'menuItem:openWithSafari',
                        'menuItem:copyUrl'
                    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                });
                // wx.updateTimelineShareData({ 
                //     title: localStorage.getItem("officeName"), // 分享标题
                //     link: that.defaultLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                //     imgUrl: 'http://wx.qlogo.cn/mmopen/ajNVdqHZLLAcbCZ2537aJrfx7HtRQvODSmwFZUsW8L58uIO54d6qrrsGjmn54S6L8XQIWIic0Qrn9e2Munibpw2ZEudxs6h4GFaicgX8iaVu7s0/64', // 分享图标
                //     success: function () {
                //         // console.log(333)
                //     // 设置成功
                //     }
                // })
                // wx.updateAppMessageShareData({ 
                //     title: localStorage.getItem("officeName"), // 分享标题
                //     desc: '让阅读有声音', // 分享描述
                //     link: that.defaultLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                //     imgUrl: 'http://wx.qlogo.cn/mmopen/ajNVdqHZLLAcbCZ2537aJrfx7HtRQvODSmwFZUsW8L58uIO54d6qrrsGjmn54S6L8XQIWIic0Qrn9e2Munibpw2ZEudxs6h4GFaicgX8iaVu7s0/64', // 分享图标
                //     success: function () {
                //         // console.log(444)
                //     // 设置成功
                //     }
                // })
                if( that.isFirstAudioLoad ){
                    that.$store.commit("setisFirstAudioLoad", false);
                    that.$refs.audio.load();
                    that.$refs.audio.play();
                }
            })
            wx.error(function(res){
                // console.log(res)
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
@keyframes rotates{
    from {
        transform: rotate(0);
    }
    to {
        transform: rotateZ(360deg);
    }
}
.miniAudio{
    position: fixed;
    right: rem(30px);
    bottom: rem(120px);
    width: rem(102px);
    height: rem(102px);
    border-radius: rem(120px);
    border: rem(4px) solid #fff;
    box-shadow: 0 0 rem(9px) rgba($color: #000000, $alpha: .36);
    z-index: 999;
    overflow: hidden;
    >div{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        >img{
            display: block;
            width: 100%;
            height: 100%;
            animation: rotates 20s linear infinite;
        }
        >div{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: rgba($color: #000000, $alpha: .5);
            >img{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: rem(50px);
                height: rem(50px);
            }
        }
    }
}
</style>
